import callFetch from 'access/callFetch'
import { createApiOptions } from 'utils'
import {
  PURCHASE_ORDER_EXACT_MATCH_URL,
  PURCHASE_ORDER_INQUIRY_URL,
  GET_PURCHASE_ORDER_TOOLTIP_URL
} from './constants'

export const purchaseOrderExactMatch = ({ keyword }) => {
  const options = createApiOptions({
    body: { description: keyword },
    method: 'post'
  })
  // console.log(options)
  return callFetch(PURCHASE_ORDER_EXACT_MATCH_URL, options)
}

export const purchaseOrderInquiry = ({
  dataId,
  productId,
  vendorId,
  status
}) => {
  const options = createApiOptions({
    method: 'post',
    body: {
      dataId,
      productId,
      vendorId,
      status
    }
  })
  return callFetch(PURCHASE_ORDER_INQUIRY_URL, options)
}

export const getPurchaseOrderTooltip = ({ dataId }) => {
  const options = createApiOptions({
    method: 'post',
    body: {
      recordName: dataId
    }
  })
  return callFetch(GET_PURCHASE_ORDER_TOOLTIP_URL, options)
}
